<template>

    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
        <div class="row">
            <h1 class="page-header">
                Email Templates
            </h1>
        </div>
        <div id="flashes" class="row"></div>
        <div class="row">
            <button type="button" class="btn btn-primary" onclick="edit(-1)" data-toggle="modal" data-backdrop="static"
                data-target="#modal"><i class="fa fa-plus"></i> New Template</button>
        </div>
        &nbsp;
        <div id="loading">
            <i class="fa fa-spinner fa-spin fa-4x"></i>
        </div>
        <div id="emptyMessage" class="row" style="display:none;">
            <div class="alert alert-info">
                No templates yet. Let's create one!
            </div>
        </div>
        <div class="row">
            <table id="templateTable" class="table" style="display:none;">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Modified Date</th>
                        <th class="col-md-2 no-sort"></th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="modalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <!-- New Template Modal -->
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="dismiss()"><span
                            aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="templateModalLabel">New Template</h4>
                </div>
                <div class="modal-body">
                    <div class="alert alert-danger alert-dismissable" role="alert" id="validation_banner">
                        Please fill the required fields in both the <strong> Email details </strong> and <strong> Landing page </strong> sections
                         <span type="button" class="close" onclick="hide_alert()" aria-label="Close"><span aria-hidden="true">&times;</span></span>
                    </div>
                    <!-- Template Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="active" role="template"><a href="#template" aria-controls="template" role="tab" data-toggle="tab">Email details</a></li>
                        <li role="landingpage"><a href="#landingpage" aria-controls="landingpage" role="tab" data-toggle="tab">Landing page</a></li>
                    </ul>
                    <!-- Template Nav panels -->
                    <form id="template_form">
                        <div class="tab-content">
                            <!-- Template panel -->
                            <div role="tabpanel" class="tab-pane active" id="template">
                                <div class="row" id="modal.flashes"></div>
                                <label class="control-label" for="name"><span>*</span>Name:</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" ng-model="template.name" placeholder="Template name" name="template_name" id="template_name"
                                        autofocus required />
                                </div>
                                <div class="form-group">
                                    <button class="btn btn-danger" data-toggle="modal" data-backdrop="static" data-target="#importEmailModal"><i
                                            class="fa fa-envelope"></i>
                                        Import Email</button>
                                </div>
                                <label class="control-label" for="envelope-sender">Envelope Sender: <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="right" title="This sender is shown to the user by most email clients. Defaults to the SMTP From as defined in the Sending Profile."></i></label>
                                <div class="form-group">
                                    <input type="text" class="form-control" name="envelope_sender" placeholder="First Last <test@example.com>" id="envelope-sender" />
                                </div>
                                <label class="control-label" for="subject">Subject:</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Email Subject" id="subject" />
                                </div>
                                <!-- Nav tabs -->
                                <div class="form-text-info">
                                    One of the "Text" or "HTML" field must be filled in
                                </div>
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="active" role="text"><a href="#text" aria-controls="text" role="tab" data-toggle="tab">Text</a></li>
                                    <li role="html"><a href="#html" aria-controls="html" role="tab" data-toggle="tab">HTML</a></li>
                                </ul>
                                <!-- Tab panes -->
                                <div class="tab-content" name="editor">
                                    <div role="tabpanel" class="tab-pane active" id="text">
                                        <textarea rows="10" name="text_editor" id="text_editor" class="gophish-editor form-control" placeholder="Plaintext"></textarea>
                                    </div>
                                    <div role="tabpanel" class="tab-pane" id="html">
                                        <textarea name="html_editor" id="html_editor"></textarea>
                                    </div>
                                </div>
                                <div class="checkbox checkbox-primary">
                                    <input id="use_tracker_checkbox" type="checkbox" checked>
                                    <label for="use_tracker_checkbox">Add Tracking Image</label>
                                </div>
                                <span class="btn btn-danger btn-file"><i class="fa fa-plus"></i> Add Files
                                    <input id="attachmentUpload" type="file" onchange="attach(this.files)" multiple>
                                </span>
                                <br />
                                <br />
                                <table id="attachmentsTable" class="table">
                                    <thead>
                                        <tr>
                                            <th class="col-md-1 no-sort"></th>
                                            <th class="col-md-10">Name</th>
                                            <th class="col-md-1 no-sort"></th>
                                            <th class="datatable_hidden no-sort">Content</th>
                                            <th class="datatable_hidden no-sort">Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Landing page panel -->
                            <div role="tabpanel" class="tab-pane" id="landingpage">
                                <div class="row" id="modal.flashes"></div>
                                <label class="control-label" for="name"><span>*</span>Name:</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Page name" id="page_name" name="page_name" autofocus required />
                                </div>
                                <div class="form-group">
                                    <button class="btn btn-danger" data-toggle="modal" data-backdrop="static" data-target="#importSiteModal"><i
                                            class="fa fa-globe"></i>
                                        Import Site</button>
                                </div>
                                <div class="form-text-info">
                                    The "HTML" field must be filled in
                                </div>
                                <!-- Nav tabs -->
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="active" role="html_landpages"><a href="#html_landpages" aria-controls="html_landpages" role="tab" data-toggle="tab">HTML</a></li>
                                </ul>
                                <!-- Tab panes -->
                                <div class="tab-content">
                                    <div role="tabpanel" class="tab-pane active" id="html_landpages">
                                        <textarea name="html_editor_landpages" id="html_editor_landpages"></textarea>
                                    </div>
                                </div>
                                <div class="checkbox checkbox-primary">
                                    <input id="capture_credentials_checkbox" type="checkbox">
                                    <label for="capture_credentials_checkbox">Capture Submitted Data <i class="fa fa-question-circle"
                                            data-toggle="tooltip" data-placement="right" title="If the landing page contains a form, submitted input (except passwords!) will be captured."></i></label>
                                </div>
                                <div class="checkbox checkbox-primary" id="capture_passwords">
                                    <input id="capture_passwords_checkbox" type="checkbox">
                                    <label for="capture_passwords_checkbox">Capture Passwords</label>
                                    <div class="alert alert-warning">
                                        <i class="fa fa-exclamation-circle"></i> <b>Warning:</b> Credentials are currently <b>not
                                            encrypted</b>. This means that captured passwords are stored in the database as cleartext.
                                        Be careful with this!
                                    </div>
                                </div>
                                <div id="redirect_url">
                                    <label class="control-label" for="redirect_url_input">Redirect to: <i class="fa fa-question-circle"
                                            data-toggle="tooltip" data-placement="right" title="This option lets you redirect the user to a page after credentials are submitted."></i></label>
                                    <div class="form-group">
                                        <input id="redirect_url_input" class="form-control" placeholder="http://example.com" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <hr>
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default" onclick="dismiss()">Cancel</button>
                    <button type="button" class="btn btn-primary" id="modalSubmit">Save Template</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="importEmailModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <!-- New Email Modal -->
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="importEmailModalLabel">Import Email</h4>
                </div>
                <div class="modal-body">
                    <div class="row" id="modal.flashes"></div>
                    <label class="control-label" for="email">Email Content:</label>
                    <div class="form-group">
                        <textarea rows="10" id="email_content" class="gophish-editor form-control" placeholder="Raw Email Source"></textarea>
                    </div>
                    <div class="checkbox checkbox-primary">
                        <input id="convert_links_checkbox" type="checkbox" checked>
                        <label for="convert_links_checkbox">Change Links to Point to Landing Page</label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">Cancel</button>
                    <button type="button" class="btn btn-primary" id="modalSubmit" onclick="importEmail()">Import</button>
                </div>
            </div>
        </div>
    </div>
    <!--Import site modal-->
    <div class="modal fade" id="importSiteModal" tabindex="-1" role="dialog" aria-labelledby="importSiteModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <!-- New Template Modal -->
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="importSiteModalLabel">Import Site</h4>
                </div>
                <div class="modal-body">
                    <div class="row" id="modal.flashes"></div>
                    <label class="control-label" for="url">URL:</label>
                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="https://example.com" id="url" autofocus />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">Cancel</button>
                    <button type="button" class="btn btn-primary" id="modalSubmit" onclick="importSite()">Import</button>
                </div>
            </div>
        </div>
    </div>

</template>
  
  <script>
  export default {
    name: 'TemplateComponent',
    //props: {
    //  msg: String
    //}
    mounted() {

        let customScript = document.createElement('script')
        customScript.setAttribute('src', '/scripts/templates.js')
        customScript.setAttribute('type', 'application/javascript')
        document.head.appendChild(customScript)

        let customScript2 = document.createElement('script')

    customScript2.setAttribute('src', '/scripts/utils.js')

    customScript2.setAttribute('type', 'application/javascript')

    document.head.appendChild(customScript2)
    }
  }
  </script>
  

  <style>

    .form-text-info{
        color: grey;
        font-size: 1.2rem;
    }
  
  </style>